import { useState } from 'react';
import PropTypes from 'prop-types';
import { CurrentUserRoleContext } from 'components/providers/CurrentUserRoleProvider/CurrentUserRoleContext';
import { getUserRoleFromSessionStorage } from 'utils/sessionStorage';

export const CurrentUserRoleProvider = ({ children }) => {
	const initialUserRole = getUserRoleFromSessionStorage();
	const [currentUserRole, setCurrentUserRole] = useState(initialUserRole);
	return (
		<CurrentUserRoleContext.Provider
			value={{
				currentUserRole,
				setCurrentUserRole,
			}}>
			{children}
		</CurrentUserRoleContext.Provider>
	);
};

CurrentUserRoleProvider.propTypes = {
	children: PropTypes.node,
};
